import React, {FC, useContext, useEffect} from "react";
import "swiper/css";
import { GamePreview } from "../../../common/components/GamePreview";

const GamePreviewPage: FC = () => {
  return <GamePreview />
};

export default GamePreviewPage;
